<script>
export default {
  name: 'RelatedCaseList',
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    edit(indexToEdit) {
      this.$emit('related-case-edit', indexToEdit);
    },
    remove(indexToRemove) {
      const relatedCases = this.value.filter((_, index) => index !== indexToRemove);

      this.$emit('input', relatedCases);
    },
    displayAddress: function () {
      return Array.from(arguments)
        .filter((item) => item)
        .join(', ');
    },
  },
};
</script>

<template>
  <div>
    <b-list-group :flush="true" class="p-0">
      <b-list-group-item v-for="(item, index) in value" :key="index">
        <div class="row">
          <div class="col-lg-7 inline-block text-lg-left text-center">
            <span class="align-middle">
              {{
                displayAddress(
                  item.related_property_address.organisation_name,
                  item.related_property_address.thoroughfare,
                  item.related_property_address.premise,
                  item.postal_code,
                )
              }}
            </span>
          </div>

          <div class="col-lg-5">
            <div class="col-lg-12 text-center text-lg-right">
              <button :id="'edit_related_case_' + index" @click="edit(index)" class="btn btn-edit my-1 mx-2"></button>

              <button
                :id="'remove_related_case_' + index"
                @click="remove(index)"
                class="btn btn-remove my-1 mx-2"
              ></button>
            </div>
          </div>
        </div>
      </b-list-group-item>
    </b-list-group>
  </div>
</template>
